var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "site-header-root" }, [
    _c(
      "header",
      {
        ref: "header",
        staticClass: "site-header",
        class: {
          scrolled: _vm.scrolled || !_vm.isHomepage,
          "sub-header": !_vm.isHomepage,
          "menu-open": _vm.menuOpen
        },
        attrs: { id: "siteHeader" }
      },
      [
        _c(
          "div",
          { staticClass: "container nav-inner" },
          [
            _c(
              "router-link",
              {
                staticClass: "brand",
                attrs: { to: "/", "aria-label": _vm.$t("site.company") },
                nativeOn: {
                  click: function($event) {
                    return _vm.closeMenu.apply(null, arguments)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "brand-logo",
                  attrs: {
                    src: require("@/assets/images/logo.png"),
                    alt: _vm.$t("site.brand")
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "brand-text" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.$t("site.brand")))])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "nav",
              {
                staticClass: "main-nav",
                class: { open: _vm.menuOpen },
                attrs: {
                  id: "mainNav",
                  "aria-label": _vm.$t("site.navigation")
                }
              },
              [
                _vm._l(_vm.sections, function(id) {
                  return _c(
                    "a",
                    {
                      key: id,
                      staticClass: "nav-link",
                      class: {
                        active: _vm.isHomepage && _vm.activeSection === id
                      },
                      attrs: { href: "#/?section=" + id },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.navigate(id)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("site." + id)))]
                  )
                }),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary nav-cta",
                    attrs: { to: "/signup" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.closeMenu.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("site.signup")))]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "header-actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary nav-download",
                  attrs: { type: "button" },
                  on: { click: _vm.openDownloadDialog }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _c("path", {
                        attrs: { d: "M12 3v12m-4-4 4 4 4-4M5 9H3v11h18V9h-2" }
                      })
                    ]
                  ),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("site.download")) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "lang-switch",
                  attrs: {
                    role: "group",
                    "aria-label": _vm.$t("site.language")
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "lang-btn",
                      class: { active: _vm.$i18n.locale === "zh" },
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.$i18n.locale === "zh"
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("zh")
                        }
                      }
                    },
                    [_vm._v("汉文")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "lang-btn",
                      class: { active: _vm.$i18n.locale === "mn" },
                      attrs: {
                        type: "button",
                        "aria-pressed": _vm.$i18n.locale === "mn"
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("mn")
                        }
                      }
                    },
                    [_vm._v("Монгол")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "nav-toggle",
                  class: { open: _vm.menuOpen },
                  attrs: {
                    type: "button",
                    "aria-label": _vm.$t(
                      _vm.menuOpen ? "site.menuClose" : "site.menuOpen"
                    ),
                    "aria-expanded": _vm.menuOpen,
                    "aria-controls": "mainNav"
                  },
                  on: {
                    click: function($event) {
                      _vm.menuOpen = !_vm.menuOpen
                    }
                  }
                },
                [_c("span"), _c("span"), _c("span")]
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.menuOpen
          ? _c("button", {
              staticClass: "nav-backdrop",
              attrs: { type: "button", "aria-label": _vm.$t("site.menuClose") },
              on: { click: _vm.closeMenu }
            })
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.downloadDialogOpen
      ? _c(
          "div",
          {
            staticClass: "download-modal-mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeDownloadDialog.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "section",
              {
                ref: "downloadDialog",
                staticClass: "download-modal",
                attrs: {
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-labelledby": "downloadDialogTitle",
                  tabindex: "-1"
                }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "download-modal-close",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("site.downloadDialogClose")
                    },
                    on: { click: _vm.closeDownloadDialog }
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c("h2", { attrs: { id: "downloadDialogTitle" } }, [
                  _vm._v(_vm._s(_vm.$t("site.downloadDialogTitle")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "download-modal-intro" }, [
                  _vm._v(_vm._s(_vm.$t("site.downloadDialogIntro")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "download-qr-wrap" }, [
                  _vm.qrCodeData
                    ? _c("img", {
                        staticClass: "download-qr",
                        attrs: {
                          src: _vm.qrCodeData,
                          alt: _vm.$t("site.downloadQrAlt")
                        }
                      })
                    : _c("p", { staticClass: "download-qr-loading" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.qrCodeFailed
                                ? "site.downloadQrFailed"
                                : "site.downloadQrLoading"
                            )
                          )
                        )
                      ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "download-link-label" }, [
                  _vm._v(_vm._s(_vm.$t("site.downloadLinkLabel")))
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "download-url",
                    attrs: { href: _vm.downloadUrl, download: "eruul.apk" }
                  },
                  [_vm._v(_vm._s(_vm.downloadUrl))]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "download-tip" }, [
                  _vm._v(_vm._s(_vm.$t("site.downloadBrowserTip")))
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary download-copy",
                    attrs: { type: "button" },
                    on: { click: _vm.copyDownloadLink }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            _vm.linkCopied
                              ? "site.downloadCopied"
                              : "site.downloadCopy"
                          )
                        ) +
                        "\n      "
                    )
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13877386", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13877386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 